// disable link to product page
document.addEventListener("DOMContentLoaded", function() {
    const ariaLinks = document.querySelectorAll('a[aria-label="Product link"]');
    const titleLinks = document.querySelectorAll('.collection-product-card .card__title a');

    const allLinks = [...ariaLinks, ...titleLinks];

    allLinks.forEach(link => {
      link.removeAttribute("href");
      link.style.pointerEvents = "none";
      link.style.cursor = "default";

      link.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    });
});

//single product : move content popup and wrap button
document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('.product__info-main_content');
  if (!content) return;

  const popups = content.querySelectorAll('.product-popup');
  if (!popups.length) return;

  const quantity = content.querySelector('.product-form__quantity');
  if (!quantity) return;

  const popupWrapper = document.createElement('div');
  popupWrapper.className = 'product-popup-wrapper';

  popups.forEach(p => popupWrapper.appendChild(p));

  quantity.insertAdjacentElement('afterend', popupWrapper);

  const submitBtn = content.querySelector('.product-form__submit');
  const checkout = content.querySelector('.product-form__checkout');

  if (submitBtn && checkout) {
    const buyWrap = document.createElement('div');
    buyWrap.className = 'buy-wrapper';

    submitBtn.insertAdjacentElement('beforebegin', buyWrap);
    buyWrap.appendChild(submitBtn);
    buyWrap.appendChild(checkout);
  }
});


